import { render, staticRenderFns } from "./mallSure.vue?vue&type=template&id=71dcb301&scoped=true"
import script from "./mallSure.vue?vue&type=script&lang=js"
export * from "./mallSure.vue?vue&type=script&lang=js"
import style0 from "./mallSure.vue?vue&type=style&index=0&id=71dcb301&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71dcb301",
  null
  
)

export default component.exports